import React from 'react';
import BackfillPropelIds from '../components/admin/BackfillPropelIds';
import './BackfillPage.css';

const BackfillPage = () => (
  <div className="backfill-page">
    <div className="backfill-page-header">
      <img src={require('../assets/propel-logo-darkbg.png')} alt="Propel" className="backfill-logo" />
    </div>
    <div className="backfill-page-content">
      <BackfillPropelIds apiBase="/api" />
    </div>
  </div>
);

export default BackfillPage;
